// extracted by mini-css-extract-plugin
module.exports = {"queueButton":"styles_queueButton___Pf9b","isMobile":"styles_isMobile__9MhPp"};